export default __webpack_public_path__ + "static/media/Torpedo-2.7b9d89a5.png";